module.exports = __webpack_public_path__ + "img/lang-kz.2177ccec.svg";